import { UserDisplay } from "../../../../../../design-system/components/UserDisplay/UserDisplay.jsx";
import GroupBox from "../GroupBox/GroupBox.jsx";
import styles from "./PendingTeacherList.css.ts";

/**
 * Renders a list of pending teacher invitations, displaying their email addresses.
 *
 * @param {Object} props - The component props.
 * @param {Array<Object>} props.teachers - An array of teacher objects, where each object contains teacher details.
 * @param {string} props.teachers[].id - The unique identifier for a teacher.
 * @param {string} props.teachers[].email - The email address of the teacher.
 * @return {JSX.Element|null} A rendered list of pending teacher invitations, or null if no teachers are provided.
 */
function PendingTeacherList({ teachers }) {
  if (!teachers.length) return null;

  return (
    <GroupBox headline="Ausstehende Einladungen">
      <ul className={styles.teacherList}>
        {teachers.map((teacher) => (
          <li key={teacher.id}>
            <UserDisplay
              brighterBackground
              user={{
                id: teacher.id,
                name: teacher.email,
              }}
            />
          </li>
        ))}
      </ul>
    </GroupBox>
  );
}

export default PendingTeacherList;
